import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { Button } from '@lightspeed/flame/Button';
import Group from '@lightspeed/cirrus-group';
import { IconSmallChevronDown } from '@lightspeed/flame/Icon/SmallChevronDown';
import { IconEdit } from '@lightspeed/flame/Icon/Edit';
import { IconSync } from '@lightspeed/flame/Icon/Sync';
import { IconDelete } from '@lightspeed/flame/Icon/Delete';
import Text from '@lightspeed/cirrus-text';

import Menu, { MenuItem } from 'pages/components/Menu';

import { PoBtn } from './VendorReturnItemListing.style';

const selectPurchaseOrder = ({ vendorReturnID, vendorReturnItemID, itemID, vendorID, disabled }) =>
  window.doServerCall(
    {
      form_name: 'listing.dofunction',
      ajax_listing: JSON.stringify({
        draw_all: false,
        draw_tab_only: false,
        name: 'vendor_return.listings.items',
        is_child_list: '1',
        display_search: '0',
        saved_search: {
          vendor_return_id: vendorReturnID,
          status: 'open',
        },
        tab: 'single',
        page_controls: true,
        title: 'Items',
        deleted_rows: null,
        row_num: 2,
        rec_num: parseFloat(vendorReturnID),
      }),
      fnc: 'change_order_fnc',
      key_values: JSON.stringify({
        vendor_return_id: vendorReturnID,
        status: 'open',
      }),
      row: JSON.stringify({
        can_edit: !disabled,
        vendor_return_item_id: vendorReturnItemID,
        item_id: itemID,
        vendor_id: vendorID,
      }),
      pannel_id: 'view',
    },
    window.cb_dolistingfunction
  );

const removePurchaseOrder = ({ updateVendorReturnItem, itemID }) => {
  updateVendorReturnItem({
    itemID,
    payload: {
      vendorReturnItem: { orderID: null },
    },
    onSuccess: () => window.flashNotifier('success', 'Vendor return item updated.', 3),
  });
};

const PurchaseOrderSelect = ({
  disabled,
  purchaseOrder,
  vendorReturnItemID,
  itemID,
  vendorID,
  vendorReturnID,
  updateVendorReturnItem,
}) => {
  if (!disabled && purchaseOrder) {
    return (
      <Menu
        light
        placement="bottom-end"
        target={
          <PoBtn role="button" data-test="listing-po-menu">
            {purchaseOrder}
            <IconSmallChevronDown />
          </PoBtn>
        }
      >
        {({ onClose }) => (
          <Fragment>
            <MenuItem
              data-test="listing-po-menu-view"
              onClick={() => {
                window.navigateToContent('view', 'purchase.views.purchase', purchaseOrder);
                onClose();
              }}
            >
              <Group>
                <IconEdit />

                <Text color="blue">
                  View PO <var>{purchaseOrder}</var>
                </Text>
              </Group>
            </MenuItem>
            <MenuItem
              data-test="listing-po-menu-change"
              onClick={() => {
                selectPurchaseOrder({
                  vendorReturnID,
                  vendorReturnItemID,
                  itemID,
                  vendorID,
                  disabled,
                });
                onClose();
              }}
            >
              <Group>
                <IconSync />
                <Text color="blue">Select other PO</Text>
              </Group>
            </MenuItem>
            <MenuItem
              data-test="listing-po-menu-delete"
              onClick={() => {
                removePurchaseOrder({ updateVendorReturnItem, itemID });
                onClose();
              }}
            >
              <Group>
                <IconDelete />
                <Text color="blue">Remove PO</Text>
              </Group>
            </MenuItem>
          </Fragment>
        )}
      </Menu>
    );
  }

  if (!disabled && !purchaseOrder) {
    return (
      <Button
        variant="secondary"
        size="small"
        data-test="listing-po-button"
        onClick={() => {
          selectPurchaseOrder({ vendorReturnID, vendorReturnItemID, itemID, vendorID, disabled });
        }}
      >
        Select <IconEdit size="0.75rem" />
      </Button>
    );
  }

  return <span data-test="listing-po-text">{purchaseOrder || 'N/A'}</span>;
};

PurchaseOrderSelect.propTypes = {
  disabled: PropTypes.bool,
  purchaseOrder: PropTypes.number,
  vendorID: PropTypes.number,
  vendorReturnID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  updateVendorReturnItem: PropTypes.func,
};

export default PurchaseOrderSelect;
